<script>
	import { handleNav } from "$lib/utilities/handleNav";
	import { translate } from "$lib/utilities/translate";
	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import { slugify } from "cando-util";

	export let data;
	export let lang;

	const showIframe = {};

	$: floatingMenus = data?.content?.settings?.FloatingMenu || {};

	$: actions = Object.keys(floatingMenus)
		.filter(
			(k) =>
				k.startsWith("Action ") &&
				["Icon"].filter((s) => k.endsWith(` ${s}`)).length === 0,
		)
		.sort()
		.map((k) => ({
			key: k,
			actionLabel: translate(floatingMenus[k].value?.label, lang),
			actionHref: floatingMenus[k].value?.href?.value,
			iframeSrc: floatingMenus[k].value?.iframeSrc?.value,
			icon: floatingMenus?.[`${k} Icon`]?.value?.icon
				? JSON.parse(floatingMenus?.[`${k} Icon`]?.value?.icon || "{}")
				: undefined,
			function: floatingMenus[k].value?.href?.value
				? handleNav
				: () => {
						// I'm just assuming that without an href, this is the chat widget...
						showIframe[k] = !showIframe[k];
					},
		}));
	$: baseContainerClass = `w-full sm:w-auto flex justify-between sm:flex-col sm:items-end gap-2 sm:gap-4 rounded-full p-2`;
	$: containerClass = `${baseContainerClass} border-2 border-primary bg-base-100`;
	$: baseButtonClass = `hover-ripple rounded-full sm:btn-xl w-16 h-16 whitespace-nowrap p-0 hover:cursor-pointer transition-all duration-300`;
	$: buttonClass = `${baseButtonClass} shadow-lg bg-primary border-2 border-primary text-primary-content hover:bg-primary-content hover:text-primary`;
	$: asideClass =
		floatingMenus?.classes?.value?.asideClass?.value ||
		"fixed bottom-4 sm:right-4 flex flex-row justify-between sm:flex-col sm:items-end gap-2 z-50 w-full sm:w-auto";
</script>

{#if actions.length > 0}
	<aside class={asideClass}>
		<div class={containerClass}>
			{#each actions as action}
				<button
					class={buttonClass}
					onclick={action.function}
					href={action.actionHref}
				>
					<div class="text-sm sm:block">
						{#if action.icon}
							<div class="flex items-center justify-center">
								<SvelteFa icon={action.icon} size="1.5x" />
							</div>
						{/if}
						{#if action.actionLabel}
							<div>
								{action.actionLabel}
							</div>
						{/if}
					</div>
				</button>
				{#if showIframe[action.key]}
					<div
						id={`${slugify(action.key)}-floating-menu-iframe`}
						class="fixed bottom-16 sm:right-32 w-[320px] h-150 bg-base-300 shadow-xl rounded overflow-hidden z-60"
					>
						<iframe
							title="Chat"
							src={action.iframeSrc}
							width="100%"
							height="600"
							frameborder="0"
						></iframe>
					</div>
				{/if}
			{/each}
		</div>
	</aside>
{/if}
